var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-image-picker',{attrs:{"data":_vm.data,"upload_url":"https://jsonplaceholder.typicode.com/posts","search_key":"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }